import { useGlobalMapActions } from "contexts/map";
import * as S from "./styles";
import { OccurrenceMarkerCard } from "../OccurrenceMarkerCard";
import { IMapLocationData } from "contexts/map/types";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";

export function MapFavoriteList() {
  const {
    locations,
    selectedMarker,
    handleFavoriteClick,
    handleMapCenterChange,
  } = useGlobalMapActions();

  const { setOccurrenceToEditId } = useManualOccurrence();

  const favoriteMarkers = locations.filter((el) => el.isFavorite === true);

  function handleCardFavoriteClick(marker: IMapLocationData) {
    handleFavoriteClick({
      location: marker,
      type: "occurrence",
    });
  }

  function handleOccurrenceMoreDetailsClick(occurrenceId: string) {
    setOccurrenceToEditId(occurrenceId);
  }

  if (favoriteMarkers.length === 0) {
    return (
      <S.EmptyWrapper>
        <h3>Nenhuma localização salva atualmente</h3>
      </S.EmptyWrapper>
    );
  }

  return (
    <div>
      {favoriteMarkers.map((marker) => (
        <OccurrenceMarkerCard
          marker={marker}
          isSelected={selectedMarker?.dataId === marker.dataId}
          onFavoriteClick={() => handleCardFavoriteClick(marker)}
          onMapLocationChange={handleMapCenterChange}
          onMoreDetailsClick={handleOccurrenceMoreDetailsClick}
        />
      ))}
    </div>
  );
}
